<template>
  <div class="branded-fare-upsell__content branded-fare-upsell-swiper">
    <swiper
      ref_id="swiper-upsell"
      :swiper_params="swiper_params"
      class="branded-fare-upsell__swiper"
      @swiper-initialized="on_swiper_initialized"
    >
      <swiper-slide
        v-for="(item, index) in flight_offers_upsell"
        :key="`${_uid}:${item.id}:${index}`"
        :class="`branded-fare-upsell__wrapper branded-fare-upsell__wrapper--${toggle_selected_class(
          item,
          selected_flight_offer_id,
        )}`"
      >
        <branded-fare-upsell-swiper-item
          :item="item"
          :index="index"
          :selected_flight_offer_id="selected_flight_offer_id"
          :flight_offer_default="flight_offer_default"
          :amenities="amenities_by_offer_id[item.id] || []"
          @select-flight-offer="on_select_flight_offer"
        />
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import Swiper from "@/components/blocks/swiper.vue";
import BrandedFareUpsellSwiperItem from "./branded-fare-upsell-swiper-item.vue";
import { toggle_selected_class } from "./logic";

export default {
  name: "branded-fare-upsell-swiper",
  components: {
    swiper: Swiper,
    "branded-fare-upsell-swiper-item": BrandedFareUpsellSwiperItem,
  },
  props: {
    flight_offers_upsell: { type: Array, default: () => [] },
    selected_flight_offer_id: [String, Number],
    swiper_params: Object,
    flight_offer_default: Object,
    amenities_by_offer_id: { type: Object, default: () => ({}) },
  },
  methods: {
    toggle_selected_class,
    on_select_flight_offer(item) {
      this.$emit("select-flight-offer", item);
    },
    on_swiper_initialized(swiper_instance) {
      this.$emit("swiper-initialized", swiper_instance);
    },
  },
};
</script>
